// import logo from './logo.svg';
import './App.css';
import { createBrowserRouter, RouterProvider, } from "react-router-dom"
import Page404 from './Layout/Page404';
import {ConfigContext, ConfigProvider} from '../src/Context/ConfigContext'

import routes from './Routes/Routes'
import AppLayout from './Layout/AppLayout';
import './i18n'
import {jwtDecode} from 'jwt-decode';
import { useEffect } from 'react';
import axios from 'axios';
import { useContext } from 'react';
import BasketLayout from './Layout/BasketLayout';
// import { LanguageProvider } from './Context/LanguageContex';


const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: routes.filter(route => !route.path.startsWith('/basket'))
  },
  {
    path: '/basket',
    element: <BasketLayout />,
    children: routes.filter(route => route.path.startsWith('/basket'))
  }
]);

function App() {
  
  // Generate and store session ID if not exists
  if (!localStorage.getItem('session_id')) {
    const randomPart = Math.floor(1000 + Math.random() * 9000); // 4 random digits
    const timestamp = Date.now().toString().slice(-2); // Last 2 digits of timestamp
    const sessionId = `${timestamp}-${randomPart}`;
    localStorage.setItem('session_id', sessionId);
  }

  // localStorage.setItem('car_info','');
  if(!localStorage.getItem('currency')){
    localStorage.setItem('currency', 'aed');
  }
  if(localStorage.getItem('token')){
    const decodedToken = jwtDecode(localStorage.getItem('token'), {complete: true});
    const currentTime = Date.now() / 1000; 
    if (decodedToken.exp < currentTime) {
      localStorage.setItem('token', '');
      localStorage.setItem('customer_id', '');
      localStorage.setItem('email_address', '');
      localStorage.setItem('first_name', '');
      localStorage.setItem('mobile_number', '');
      // alert("token expired")
      const expiryTimeInSeconds = decodedToken.exp - currentTime;
      const expiryTimeInMinutes = Math.floor(expiryTimeInSeconds / 60);
      
    }else{
      const expiryTimeInSeconds = decodedToken.exp - currentTime;
      const expiryTimeInMinutes = Math.floor(expiryTimeInSeconds / 60) / 60;
      // alert(expiryTimeInMinutes)
      // alert(decodedToken.exp+"-"+currentTime)
    }
  }
  
  useEffect(() => {
    // try{
    // if( isTokenExpired(localStorage.getItem('token'))){
    //   localStorage.setItem('token', '');
    //   localStorage.setItem('customer_id', '');
    //   localStorage.setItem('email_address', '');
    //   localStorage.setItem('first_name', '');
    //   localStorage.setItem('mobile_number', '');
    // }
    // }catch(eerr){
      
    // }
  }, [])
  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
     
      return decoded.exp < currentTime; // Check if token is expired
    } catch (error) {
      console.error("Invalid token:", error);
      return true; // Treat invalid tokens as expired
    }
  };
  return (
    // <LanguageProvider>      
      <ConfigProvider>
        <RouterProvider router={router} />
      </ConfigProvider>
    // </LanguageProvider>
  )
}

export default App;
